<template>
    <div class="forum" v-wechat-title="$route.meta.title">
        <!-- banner -->
        <section class="banner-wrapper">
            <el-carousel trigger="click" height="460px" class="forum-banner-carousel">
                <el-carousel-item v-for="banner in bannerCarouselList" :key="banner.id" :interval="5000">
                    <div
                        :style="{height: '100%', cursor: 'pointer', background: 'url(' + banner.img + ') no-repeat center center', backgroundSize:'cover'}"
                        @click="goActivity(banner)"
                        :src="banner.img"></div>
                </el-carousel-item>
            </el-carousel>
            <ul class="banner-box">
                <li
                    class="banner-item"
                    v-for="content in bannerContent"
                    :key="content.index"
                    @click="goActivity(content)">
                    <img class="icon" :src="content.img" alt="">
                    <div class="banner-info">
                        <p class="title">{{ content.title }}</p>
                        <p class="content">{{ content.content }}</p>
                    </div>
                </li>
            </ul>
        </section>
        <!-- 推荐问答 -->
        <section class="recommend-qa">
            <p class="title">
                <img src="../images/community/qa.png" alt="">
                推荐问答
            </p>
            <div class="qa-wrapper">
                <ul class="qa-content" v-loading="isQaLoading">
                    <li
                        class="qa-item"
                        v-for="(qaItem, qaIdx) in qaList"
                        :key="qaIdx">
                        <div class="qa-left" @click="goQuestionDetail(qaItem, true)">
                            <p class="count">{{ qaItem.no_of_comment }}</p>
                            <p>回复</p>
                        </div>
                        <div class="qa-right">
                            <p class="title" @click="goQuestionDetail(qaItem)">{{ qaItem.title }}</p>
                            <ul class="tags">
                                <li v-for="(tag, tagIdx) in qaItem.tags" :key="tagIdx" @click="goSearch(tag)">
                                    {{ tag.title }}
                                </li>
                            </ul>
                            <div class="footer">
                                <div class="footer-item">
                                    <i class="smart-icon view-icon"></i>
                                    {{ qaItem.no_of_views }}
                                </div>
                                <div :class="['footer-item', { 'is-active': qaItem.is_followed }]" @click="focusToggle(qaItem)">
                                    <i class="smart-icon follow-icon"></i>
                                    {{ qaItem.no_of_followed }}
                                </div>
                                <div class="footer-item" @click="goHomePage(qaItem.created_by)">
                                    <el-popover
                                        popper-class="user-card"
                                        placement="top"
                                        :open-delay="500"
                                        width="400"
                                        trigger="hover"
                                        @show="$refs['card' + qaItem.created_by.id + qaIdx][0].getUserInfo()">
                                        <div style="text-align: right; margin: 0, padding: 0">
                                            <user-card :ref="`card${qaItem.created_by.id}${qaIdx}`" :user-id="qaItem.created_by.id"></user-card>
                                        </div>
                                        <div slot="reference" class="user-avatar">
                                            <img
                                                class="user-logo"
                                                src="../images/personal_center/avatar_default.png"
                                                v-if="!qaItem.created_by.user_logo || qaItem.created_by.user_logo.substr(0, 1) === '?'">
                                            <img class="user-logo" v-else :src="qaItem.created_by.user_logo" alt="">
                                            <span class="user-name">{{ qaItem.created_by.nick_name }}</span>
                                        </div>
                                    </el-popover>
                                    <el-tooltip v-if="qaItem.created_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                                        <svg style="width: 20px; height: 20px" aria-hidden="true">
                                            <use xlink:href="#icon-lanjingguanfang"></use>
                                        </svg>
                                    </el-tooltip>
                                    <el-tooltip v-if="qaItem.created_by.is_vip" effect="light" content="核心用户标识" placement="right">
                                        <span class="icon-vipuser"></span>
                                    </el-tooltip>
                                    <span @click.stop>{{ getTime(qaItem.created_on) }}</span>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <p class="more" @click="goToDoc({url: '/s-mart/community/question'})">
                    <span>查看全部</span>
                    <i class="arrow-right-icon"></i>
                </p>
                <!-- 活跃答主 -->
                <div class="respondent-content" v-loading="isActiveUserLoading">
                    <div class="active-title">
                        <span class="title">活跃答主</span>
                        <div class="data-switch">
                            <span
                                :class="['switch-item', {'active': userRankBoard === item.type}]"
                                v-for="item in switchData"
                                :key ="item.type"
                                @click="userRankBoard = item.type">
                                {{item.title}}
                            </span>
                            <!-- 这是判断是否显示身份标记 -->
                            <!-- <img v-if="true" class="user-identity" src="../images/honor_system/coreuser.png" alt=""> -->
                        </div>
                    </div>
                    <ul v-if="activeUserList.length">
                        <li
                            :class="['active-user-item', { 'is-crown': index < 3 }]"
                            v-for="(user, index) in activeUserList"
                            :key="index"
                            @click="goHomePage({user_id: user.id})">
                            <el-popover
                                popper-class="user-card"
                                placement="top"
                                :open-delay="500"
                                width="400"
                                trigger="hover"
                                @show="$refs['card' + user.id + index][0].getUserInfo()">
                                <div style="text-align: right; margin: 0, padding: 0">
                                    <user-card :ref="`card${user.id}${index}`" :user-id="user.id"></user-card>
                                </div>
                                <div slot="reference" class="user-avatar" @click="visible = !visible">
                                    <div class="user-avatar">
                                        <img v-if="index === 0" height="48px" width="37px" src="../images/community/crown.png" alt="">
                                        <img v-if="index === 1" height="48px" width="37px" src="../images/community/crown2.png" alt="">
                                        <img v-if="index === 2" height="48px" width="37px" src="../images/community/crown1.png" alt="">
                                        <img
                                            class="avatar"
                                            src="../images/personal_center/avatar_default.png"
                                            v-if="!user.user_avatar || user.user_avatar.substr(0, 1) === '?'">
                                        <img v-else class="avatar" :src="user.user_avatar" alt="">
                                    </div>
                                </div>
                            </el-popover>
                            <div class="user-message">
                                <div style="display: flex">
                                    <p class="user-name">{{user.nickname}}</p>
                                    <el-tooltip v-if="user.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                                        <svg style="width: 20px; height: 20px" aria-hidden="true">
                                            <use xlink:href="#icon-lanjingguanfang"></use>
                                        </svg>
                                    </el-tooltip>
                                    <el-tooltip v-if="user.is_vip" effect="light" content="核心用户" placement="right">
                                        <span class="icon-vipuser"></span>
                                    </el-tooltip>
                                </div>
                                <p class="reply-info">
                                    {{user.nums}}
                                    <span>个回答</span>
                                </p>
                            </div>
                            <el-tooltip
                                v-if="user.is_followed !== null"
                                effect="dark"
                                placement="top"
                                :content="user.is_followed ? '取消关注' : '添加关注'">
                                <div
                                    :class="['follow-btn', user.is_followed ? 'followed' : 'not-follow']"
                                    @click.stop="handleToggleAttention(user)">
                                    {{ user.is_followed ? '已关注' : '关注' }}
                                </div>
                            </el-tooltip>
                        </li>
                    </ul>
                    <p v-else class="data-null">暂无数据</p>
                </div>
            </div>
        </section>
        <!-- 推荐文章 -->
        <section class="recommend-article">
            <p class="title">
                <img src="../images/community/article.png" alt="">
                推荐文章
            </p>
            <div class="article-content">
                <ul class="article-list" v-loading="isArticleLoading">
                    <li
                        class="article-item"
                        v-for="(articleItem, articleIdx) in articleList"
                        :key="articleIdx">
                        <p style="display: none;" :id="`article-item-${articleItem.id}`" class="question-desc img-hook"  v-html="filterXSS(articleItem.afterHtmlDesc)" ref="descHook"></p>
                        <div class="article-left">
                            <div class="header">
                                <div :class="[articleItem.is_reprint ? 'reprint' : 'original']">{{articleItem.is_reprint ? '转载' : '原创'}}</div>
                                <p class="title" @click="goArticleDetail(articleItem)">{{ articleItem.title }}</p>
                            </div>
                            <ul class="tags">
                                <li v-for="(tag, tagIdx) in articleItem.tags" :key="tagIdx" @click="goSearch(tag)">
                                    {{ tag.title }}
                                </li>
                            </ul>
                            <p class="desc" @click="goArticleDetail(articleItem)" v-html="filterXSS(articleItem.descText)"></p>
                            <div class="footer">
                                <div class="footer-item default">
                                    <i class="smart-icon view-icon"></i>
                                    <span class="count">{{ articleItem.no_of_views }}</span>
                                </div>
                                <div :class="['footer-item', { 'is-active': articleItem.is_me_comment }]" @click="goArticleDetail(articleItem, true)">
                                    <i class="smart-icon comment-icon"></i>
                                    <span class="count">{{ articleItem.no_of_comment }}</span>
                                </div>
                                <div :class="['footer-item', { 'is-active': articleItem.is_vote_up }]" @click="onVoteToggle(articleItem)">
                                    <i class="smart-icon like-icon"></i>
                                    <span class="count">{{ articleItem.no_of_vote_up }}</span>
                                </div>
                                <div :class="['footer-item', { 'is-active': articleItem.is_liked }]" @click="favoriteToggle(articleItem)">
                                    <i class="smart-icon collect-icon"></i>
                                    <span class="count">{{ articleItem.no_of_likes }}</span>
                                </div>
                                <div class="footer-item default" @click="goHomePage(articleItem.created_by)">
                                    <el-popover
                                        popper-class="user-card"
                                        placement="top"
                                        :open-delay="500"
                                        width="400"
                                        trigger="hover"
                                        @show="$refs['card' + articleItem.created_by.id + articleIdx][0].getUserInfo()">
                                        <div style="text-align: right; margin: 0, padding: 0">
                                            <user-card :ref="`card${articleItem.created_by.id}${articleIdx}`" :user-id="articleItem.created_by.id"></user-card>
                                        </div>
                                        <div slot="reference" class="user-avatar">
                                            <img
                                                class="user-logo"
                                                src="../images/personal_center/avatar_default.png"
                                                v-if="!articleItem.created_by.user_logo || articleItem.created_by.user_logo.substr(0, 1) === '?'">
                                            <img class="user-logo" v-else :src="articleItem.created_by.user_logo" alt="">
                                            <span class="user-name">{{ articleItem.created_by.nick_name }}</span>
                                        </div>
                                    </el-popover>
                                    <el-tooltip v-if="articleItem.created_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                                        <svg style="width: 20px; height: 20px" aria-hidden="true">
                                            <use xlink:href="#icon-lanjingguanfang"></use>
                                        </svg>
                                    </el-tooltip>
                                    <el-tooltip v-if="articleItem.created_by.is_vip" effect="light" content="核心用户" placement="right">
                                        <span class="icon-vipuser"></span>
                                    </el-tooltip>
                                    <span @click.stop>{{ getTime(articleItem.created_on) }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="article-right" v-if="articleItem.imgSrc">
                            <img :src="articleItem.imgSrc" alt="">
                        </div>
                    </li>
                </ul>
                <p class="more" @click="goToDoc({url: '/s-mart/community/article'})">
                    查看全部
                    <i class="arrow-right-icon"></i>
                </p>
                <!-- 文章排行 -->
                <div class="article-rank" v-loading="isArticleRankLoading">
                    <div class="article-title">
                        <span class="title">文章排行</span>
                        <div class="data-switch">
                            <span
                                :class="['switch-item', {'active': articleRankBoard === item.type}]"
                                v-for="item in switchData"
                                :key ="item.type"
                                @click="articleRankBoard = item.type">
                                {{item.title}}
                            </span>
                        </div>
                    </div>
                    <ul v-if="articleRankList.length">
                        <li
                            :class="['rank-item', { 'is-crown': index < 3 }]"
                            v-for="(article, index) in articleRankList"
                            :key="index">
                            <div :class="['view-box', `rank${index}`]">
                                <img v-if="index === 0" height="13px" src="../images/community/fire.png" alt="">
                                <img v-else-if="index === 1" height="13px" src="../images/community/fire2.png" alt="">
                                <img v-else-if="index === 2" height="13px" src="../images/community/fire1.png" alt="">
                                <img v-else width="16px" src="../images/community/eye-open.png" alt="">
                                <span>{{ article.no_of_views }}</span>
                            </div>
                            <div class="">
                                <p class="title" @click="goArticleDetail(article)">{{ article.title }}</p>
                                <el-popover
                                    popper-class="user-card"
                                    placement="top"
                                    :open-delay="500"
                                    width="400"
                                    trigger="hover"
                                    @show="$refs['articleCard' + article.created_by.id + index][0].getUserInfo()">
                                    <div style="text-align: right; margin: 0, padding: 0">
                                        <user-card :ref="`articleCard${article.created_by.id}${index}`" :user-id="article.created_by.id"></user-card>
                                    </div>
                                    <div slot="reference" class="user-name" style="display:inline-block">
                                        <span class="user-name" @click="goHomePage(article.created_by)">{{ article.created_by.nick_name }}</span>
                                    </div>
                                </el-popover>
                                <el-tooltip v-if="article.created_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                                    <svg style="width: 20px; height: 20px; vertical-align: middle;" aria-hidden="true">
                                        <use xlink:href="#icon-lanjingguanfang"></use>
                                    </svg>
                                </el-tooltip>
                                <el-tooltip v-if="article.created_by.is_vip" effect="light" content="核心用户" placement="right">
                                    <span class="icon-vipuser"></span>
                                </el-tooltip>
                                <span class="art_nums">{{ article.created_by.article_num }}篇文章</span>
                            </div>
                        </li>
                    </ul>
                    <p v-else class="data-null">暂无数据</p>
                </div>
            </div>
        </section>
        <!-- 课程学习 -->
        <section class="course-study">
            <p class="title">
                <img src="../images/community/study.png" alt="">
                课程学习
                <span class="more" @click="goToDoc({url: 'https://bk.tencent.com/docs/video/6.0', isCloud: true}, true)">更多 ></span>
            </p>
            <div class="course-wrapper">
                <el-carousel trigger="click" height="260px" class="course-carousel" :interval="6000">
                    <el-carousel-item v-for="(course, index) in courseList" :key="index">
                        <div class="course-item" v-for="item in course" :key="item.name" @click="handleVideoPreview(item)">
                            <div class="img"></div>
                            <div class="mask">
                                <div class="play-btn"></div>
                            </div>
                            <div class="topic">BlueKing</div>
                            <div class="name">{{ item.name }}</div>
                            <div class="duration">{{ item.desc }}</div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </section>
        <!-- 热门下载 -->
        <section class="hot-download">
            <p class="title">
                <img src="../images/community/download.png" alt="">
                热门下载
                <span class="more" @click="goToDoc({url: '/download/'}, true)">更多 ></span>
            </p>
            <ul class="download-wrapper">
                <li
                    class="download-item"
                    v-for="(info, index) in downloadList"
                    :key="index"
                    @click="goToDoc({url: 'https://bk.tencent.com/s-mart/downloads?type=packageDown&version=binary', isCloud: true }, true)">
                    <div :class="['label', { 'required': info.required }]">{{ info.required ? '必备' : '可选' }}</div>
                    <p class="title">{{ info.title }}</p>
                    <p class="desc">{{ info.desc }}</p>
                    <div class="version">
                        <span>{{ info.version }}</span>
                        <img height="24px" width="24px" src="../images/community/donwload2.png" alt="">
                    </div>
                </li>
            </ul>
        </section>
        <section class="community-edition">
            <p class="title">在线体验</p>
            <p class="desc">完全免费，所见即所得的在线体验环境。抢先体验，蓝鲸产品新功能曝光的前哨站。场景丰富，内置各行业经典案例和高级用法，并有合作伙伴提供的优质SaaS</p>
            <div class="experience-btn" @click="handleOnlineExperience">
                立即体验
            </div>
        </section>
        <el-dialog
            :visible.sync="isShow"
            center
            :close-on-click-modal="false"
            :destroy-on-close="true"
            custom-class="docs-video-dialog"
            @close="handleClose">
            <video width="100%" :src="videoUrl" autoplay controls>
                抱歉，您的浏览器不支持内嵌视频，不过不用担心，你可以 <a :href="videoUrl">下载</a>
                并用你喜欢的播放器观看!
            </video>
        </el-dialog>
    </div>
</template>

<script>
    import mavonEditor from 'mavon-editor';
    import tools from '@/js/tools.js'
    import userCard from './common/userCard.vue'
    import bus from '@/js/bus.js'
    export default {
        name: 'forum',
        components: {
            userCard
        },
        data () {
            return {
                bannerCarouselList: [],
                bannerContent: [
                    {
                        title: '社区版单产品更新公告（6.1/6.2/7.0/7.1/7.2）',
                        content: '功能升级、缺陷修复',
                        img: require('../images/community/announcement.png'),
                        url: 'https://bk.tencent.com/s-mart/community/question/5541'
                    }, {
                        title: '蓝鲸社区版各版本升级指引',
                        content: '覆盖5.X、6.X、7.X等版本',
                        img: require('../images/community/guide.png'),
                        url: 'https://bk.tencent.com/s-mart/community/question/1661'
                    }
                ],
                switchData: [
                    {
                        title: '周榜',
                        type: 'week'
                    }, {
                        title: '月榜',
                        type: 'month'
                    }
                ],
                userRankBoard: 'month',
                activeUserList: [],
                isActiveUserLoading: true,
                isQaLoading: true,
                qaList: [],
                isArticleLoading: true,
                articleList: [],
                isArticleRankLoading: false,
                articleRankBoard: 'month',
                articleRankList: [],
                downloadList: [
                    {
                        title: '基础套餐',
                        desc: '持续交付/部署(CD)场景',
                        required: true,
                        version: '社区版 6.1.2'
                    }, {
                        title: '监控日志套餐',
                        desc: '监控告警，日志采集以及故障自愈场景',
                        required: false,
                        version: '监控日志套餐'
                    }, {
                        title: '容器管理套餐',
                        desc: '基于原生K8S的容器编排',
                        required: false,
                        version: '容器管理套餐'
                    }, {
                        title: '持续集成套餐',
                        desc: '助力中小型企业快速接入并享受CI服务',
                        required: false,
                        version: '持续集成套餐',
                        url: ''
                    }
                ],
                courseList: [
                    [
                        {
                            name: '蓝鲸产品直播系列公开课',
                            desc: '11节课',
                            url: 'https://ke.qq.com/course/3101748?taid=10476971426272308',
                            target: true
                        }, {
                            name: '社区版6.0基础套餐简介',
                            desc: '2:08',
                            url: 'https://bkvideos-1252002024.cos.ap-guangzhou.myqcloud.com/Basicpackage/蓝鲸基础套餐简介.mp4'
                        }, {
                            name: 'CMDB如何管理主机 ',
                            desc: '1:29',
                            url: 'https://bkvideos-1252002024.cos.ap-guangzhou.myqcloud.com/CMDB/如何在CMDB管理主机.mp4'
                        }
                    ],
                    [
                        {
                            name: '如何使用节点管理安装蓝鲸 agent',
                            desc: '1:17',
                            url: 'https://bkvideos-1252002024.cos.ap-guangzhou.myqcloud.com/bknodeman/如何使用节点管理安装蓝鲸agent.mp4'
                        }, {
                            name: '如何在监控平台进行自定义上报',
                            desc: '2:37',
                            url: 'https://bkvideos-1252002024.cos.ap-guangzhou.myqcloud.com/bkmonitorv3/如何在监控平台进行自定义上报.mp4'
                        }, {
                            name: '标准运维如何编排流程 ',
                            desc: '1:31',
                            url: 'https://bkvideos-1252002024.cos.ap-guangzhou.myqcloud.com/bksops/标准运维如何编排流程.mp4'
                        }
                    ]
                ],
                isShow: false,
                videoUrl: ''
            }
        },
        computed: {
            isLogin () {
                return this.$store.state.isLogin
            },
            userInfo () {
                return this.$store.state.userInfo
            }
        },
        watch: {
            articleRankBoard (val) {
                this.getArticleRankList()
            },
            userRankBoard (val) {
                this.getActiveUser()
            }
        },
        created () {
            if (window.scrollY > 0) {
                $('html,body').animate({
                    scrollTop: 0
                }, 600)
            }
            this.getBannerList()
            this.getQaList()
            this.getActiveUser()
            this.getArticleList()
            this.getArticleRankList()
        },
        methods: {
            goToDoc (navInfo, blank) {
                const { url, isCloud } = navInfo
                if (blank) {
                    const link = isCloud ? url : (window.location.origin + url)
                    window.open(link,  '_blank')
                } else {
                    this.$router.push({
                        path: navInfo.url
                    })
                }
            },
            // 获取banner列表
            getBannerList () {
                try {
                    axios.get(myUrl + 'forum/banner/').then(res => {
                        if (res.data.result) {
                            const respData = res.data.data
                            this.bannerCarouselList = respData.results.filter(item => [1, 2, 3].includes(item.id))
                        }
                    })
                } catch (error) {
                    console.warn(error)
                }
            },
            goActivity (banner) {
                window.open(banner.url, '_blank')
            },
            // 获取活跃答主
            async getActiveUser () {
                try {
                    this.isActiveUserLoading = true
                    await axios.get(myUrl + `forum/comment/most_user_comments/?range=${this.userRankBoard}&page_size=6`).then((res) => {
                        if (res.data.result) {
                            const respData = res.data.data
                            this.activeUserList = respData.results
                        }
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.isActiveUserLoading = false
                }
            },
            // 前往个人主页
            goHomePage (userInfo) {
                // 判断是否为自己或者他人
                const isMatch = this.userInfo.user_id === userInfo.user_id
                const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userInfo.user_id}`
                let routeData = this.$router.resolve({
                    path
                })
                window.open(routeData.href, '_blank')
            },
            // 推荐问答
            async getQaList () {
                try {
                    this.isQaLoading = true
                    await axios.get(myUrl + 'forum/topics/', {
                        params: {
                            page: 1,
                            page_size: 3,
                            board: 'qa',
                            ordering: '-top'
                        }
                    }).then(res => {
                        const resp = res.data.data
                        this.qaList = resp.results
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.isQaLoading = false
                }
            },
            // 推荐文章
            async getArticleList () {
                try {
                    this.isArticleLoading = true
                    await axios.get(myUrl + 'forum/topics/', {
                        params: {
                            page: 1,
                            page_size: 3,
                            board: 'article',
                            ordering: '-top'
                        }
                    }).then(res => {
                        const resp = res.data.data
                        this.articleList = resp.results
                        this.articleList.forEach(item => {
                            this.$set(item, 'afterHtmlDesc', '')
                            this.$set(item, 'imgSrc', '')
                            this.$set(item, 'descText', '')
                            if (item.format !== 'Markdown') {
                                item.afterHtmlDesc = filterXSS(item.description)
                            } else {
                                const data = mavonEditor.markdownIt.render(item.description)
                                const resData = tools.setImgCustomAttr(data)
                                item.afterHtmlDesc = filterXSS(resData)
                            }
                            // 根据keyword筛选匹配的内容
                            this.$nextTick(() => {
                                const dom = document.querySelector(`#article-item-${item.id}`)
                                if (dom) {
                                    item.descText = dom.textContent
                                    item.imgSrc = dom.querySelector('img') ? dom.querySelector('img').src : ''
                                }
                            })
                        })
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.isArticleLoading = false
                }
            },
            // 前往问答详情
            goQuestionDetail (item, isComment) {
                if (isComment) {
                    localStorage.setItem('commentWrapper', true)
                }
                let routeData = this.$router.resolve({
                    name: 'Question',
                    params: {
                        wid: item.id
                    },
                    query: {
                        type: 'answer'
                    }
                })
                window.open(routeData.href, '_blank')
            },
            // 前往搜索页
            goSearch (tag) {
                const selectTag = encodeURIComponent(tag.title) || undefined
                let routeData = this.$router.resolve({
                    path: '/s-mart/community/search',
                    query: {
                        selectTag
                    }
                })
                window.open(routeData.href, '_blank')
            },
            // 关注问答&取消关注问答
            focusToggle (item) {
                try {
                    if (!this.isLogin) {
                        this.onLogin()
                        return
                    }
                    // 校验信息是否完善
                    if (!this.$store.state.informationComplete) {
                        bus.$emit('openInformationPopup');
                        return;
                    }
                    let params = {
                        topic_id: item.id,
                        is_followed: !item.is_followed
                    };
                    axios.post(myUrl + 'forum/usertopic/', qs.stringify(params)).then((res) => {
                        if (res.data.result) {
                            item.is_followed = !item.is_followed
                            let msg = ''
                            if (item.is_followed) {
                                item.no_of_followed += 1
                                msg = '关注成功'
                            } else {
                                item.no_of_followed -= 1
                                msg = '取消关注'
                            }
                            this.$message({
                                message: msg,
                                type: 'success'
                            })
                        }
                    })
                } catch (error) {
                    console.warn(error)
                }
            },
            // 关注用户/取消关注用户
            handleToggleAttention (attention) {
                try {
                    if (!this.isLogin) {
                        this.onLogin()
                        return
                    }
                    // 校验信息是否完善
                    if (!this.$store.state.informationComplete) {
                        bus.$emit('openInformationPopup');
                        return;
                    }
                    const path = attention.is_followed ? 'sns/unstar/user/' : 'sns/star/user/'
                    axios.post(myUrl + path + attention.id + "/").then((res) =>{
                        const resp = res.data
                        if(!resp.result) return
                        attention.is_followed = !attention.is_followed
                        this.$message({
                            message: attention.is_followed ? '关注成功！' : '取消关注成功！',
                            type: 'success'
                        })
                    })
                } catch (error) {
                    console.warn(error)
                }
            },
            // 获取热门话题
            async getArticleRankList () {
                try {
                    this.isArticleRankLoading = true
                    let viewOn = ''
                    if (this.articleRankBoard === 'week') {
                        viewOn = tools.getWeekDate()
                    } else {
                        viewOn = tools.getMonthDate()
                    }
                    const params = {
                        board: 'article',
                        view_on: viewOn,
                        page_size: 9,
                        ordering: '-view'
                    }
                    await axios.get(myUrl + `forum/topics/`, { params }).then((res) => {
                        if (res.data.result) {
                            const respData = res.data.data
                            this.articleRankList = respData.results
                        }
                    })
                } catch (error) {
                    console.warn(error)
                } finally {
                    this.isArticleRankLoading = false
                }
            },
            // 前往文章详情
            goArticleDetail (item, isComment) {
                if (isComment) {
                    localStorage.setItem('commentWrapper', true)
                }
                let routeData = this.$router.resolve({
                    name: 'Question',
                    params: {
                        wid: item.id
                    },
                    query: {
                        type: 'article'
                    }
                })
                window.open(routeData.href, '_blank')
            },
            // 文章点赞&文章取消点赞
            onVoteToggle (val) {
                try {
                    if (!this.isLogin) {
                        this.onLogin()
                        return
                    }
                    // 校验信息是否完善
                    if (!this.$store.state.informationComplete) {
                        bus.$emit('openInformationPopup')
                        return
                    }
                    let params = {
                        topic_id: val.id,
                        vote: val.is_vote_up ? null : true
                    }
                    axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                        if (res.data.result) {
                            val.is_vote_up = val.is_vote_up ? null : true
                            let msg = ''
                            if (val.is_vote_up) {
                                val.no_of_vote_up += 1
                                msg = '点赞成功'
                            } else {
                                val.no_of_vote_up -= 1
                                msg = '取消点赞成功'
                            }
                            this.$message({
                                message: msg,
                                type: 'success'
                            })
                        }
                    })
                } catch (error) {
                    console.warn(error)
                }
            },
            // 收藏&取消收藏
            favoriteToggle (item) {
                if (!this.isLogin) {
                    this.onLogin()
                    return
                }
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup')
                    return
                }
                let params = {
                    topic_id: item.id,
                    is_like: !item.is_liked
                };
                axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
                    if (res.data.result) {
                        item.is_liked = !item.is_liked
                        let msg = ''
                        if (item.is_liked) {
                            item.no_of_likes += 1
                            msg = '收藏成功'
                        } else {
                            item.no_of_likes -= 1
                            msg = '取消收藏成功'
                        }
                        this.$message({
                            message: msg,
                            type: 'success'
                        })
                    }
                })
            },
            // 登录
            onLogin () {
                try {
                    axios.get(myUrl + 'login/test/')
                } catch (error) {
                    console.warn(error)
                }
            },
            getTime (stringTime) {
                let minute = 1000 * 60;
                let hour = minute * 60;
                let day = hour * 24;
                let week = day * 7;
                let month = day * 30;
                let time1 = new Date().getTime(); // 当前的时间戳
                let time2 = Date.parse(new Date(stringTime)); // 指定时间的时间戳
                let time = time1 - time2;
                let result = null;
                const date = stringTime.split(' ')[0]
                if (time / month >= 1 || time / week >= 1) {
                    result = date
                }  else if (time / day >= 1) {
                    result = parseInt(time / day) + '天前';
                } else if (time / hour >= 1) {
                    result = parseInt(time / hour) + '小时前';
                } else if (time / minute >= 1) {
                    result = parseInt(time / minute) + '分钟前';
                } else {
                    result = '刚刚'
                }
                return result;
            },
            // 视频预览
            handleVideoPreview (info) {
                if (info.target) {
                    window.open(info.url, '_blank')
                    return
                }
                this.videoUrl = info.url
                this.isShow = true
            },
            // 关闭弹框
            handleClose () {
                this.videoUrl = ''
            },
            handleOnlineExperience () {
            // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup')
                    return
                }
                this.goToDoc({url: 'https://bk.tencent.com/s-mart/online-env', isCloud: true}, true)
            }
        }
    }
</script>

<style lang="scss">
    .forum-banner-carousel {
        .el-carousel__indicators {
            bottom: 45px;
            li {
                padding: 0;
                &:hover .el-carousel__button{
                    opacity: 1;
                }
            }
            .el-carousel__button {
                width: 50px;
                height: 4px;
                margin-right: 4px;
                border-radius: 3px;
            }
        }
    }
    .forum-banner-carousel, .course-carousel {
        .el-carousel__container > .el-carousel__arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba($color: #000, $alpha: 0.1) !important;
            height: 40px;
            width: 40px;
            transition: all .3s;
            .el-icon-arrow-left, .el-icon-arrow-right {
                font-size: 14px;
                opacity: 0.4;
                transition: all .3s;
            }
            &:hover {
                background: rgba($color: #000, $alpha: 0.4) !important;
                > i {
                    opacity: 1;
                }
            }
        }
    }
    .course-carousel {
        height: 260px;
        .el-carousel__container {
            height: 220px !important;
        }
        .el-carousel__item{
            display: flex;
            .course-item {
                margin-right: 22px;
                cursor: pointer;
                &:last-child {
                    margin-right: 0 !important;
                }
            }
        }
        .el-carousel__indicators {
            bottom: 0px;
            li {
                margin-right: 4px;
                .el-carousel__button {
                    height: 4px;
                    border-radius: 3px;
                    background: #63656e;
                }
                &:hover .el-carousel__button{
                    opacity: 1;
                }
            }
        }
    }
    .docs-video-dialog {
        width: 750px;
        .el-dialog__header {
            padding: 0;
            .el-dialog__headerbtn {
                top: 10px;
                right: 16px;
                font-size: 18px;
                z-index: 99;
                &:hover .el-icon-close {
                    color: #3a84ff;
                }
            }
        }
        .el-dialog__body {
            padding: 0;
            min-height: 500px;
            video {
                min-height: 500px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    @font-face{
        font-family: 'TencentSansW3';
        src : url('../fonts/TencentSansW3.otf');
    }
    @font-face{
        font-family: 'TencentSansW7';
        src : url('../fonts/TencentSansW7.otf');
    }
    .forum {
        background: #fff;
        font-family: PingFang SC, Microsoft YaHei, Helvetica, sans-serif !important;
        .banner-wrapper {
            position: relative;
            margin-bottom: 158px;
            .banner-box {
                width: 1200px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: -110px;
                z-index: 3;
                margin: 0 auto;
                display: flex;
                align-items: center;
                .banner-item {
                    width: 592px;
                    height: 130px;
                    display: flex;
                    align-items: center;
                    padding: 0px 20px 30px 40px;
                    cursor: pointer;
                    background: #ffffff;
                    box-shadow: 0px 2px 6px 4px rgba(25,25,41,0.05);
                    transition: all .3s;
                    .icon {
                        position: relative;
                        width: 70px;
                        height: 70px;
                        margin-right: 50px;
                        margin-top: 30px;
                        transition: all .3s;
                    }
                    .banner-info {
                        margin-top: 30px;
                        .title {
                            color: #313238;
                            font-size: 20px;
                            margin-bottom: 15px;
                            white-space: nowrap;
                        }
                        .content {
                            font-size: 16px;
                            color: #63656e;
                        }
                    }
                    &:first-child {
                        margin-right: 16px;
                    }
                    &:hover {
                        box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.10), 0px 2px 6px 4px rgba(25,25,41,0.05);
                        .icon {
                            margin-top: 20px;
                        }
                    }
                }
            }
        }
        .recommend-qa, .recommend-article, .course-study, .hot-download {
            > .title {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                padding-left: 10px;
                font-size: 24px;
                color: #313238;
                position: relative;
                img {
                    height: 30px;
                    margin-right: 15px;
                }
                .more {
                    position: absolute;
                    right: 0;
                    top: 10px;
                    font-size: 14px;
                    cursor: pointer;
                    color: #63656e;
                    &:hover {
                        color: #3a84ff;
                    }
                }
            }
            .tags {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                > li {
                    min-width: 60px;
                    cursor: pointer;
                    margin: 0 4px 4px 0;
                    padding: 0 6px;
                    line-height: 17px;
                    border-radius: 12px;
                    background: #f2f3f4;
                    font-size: 12px;
                    color: #63656e;
                    text-align: center;
                    &:hover {
                        background: #eaebf0;
                    }
                }
            }
            .data-switch {
                position: absolute;
                top: 26px;
                right: 20px;
                width: 80px;
                height: 22px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                padding: 0 2px;
                border-radius: 2px;
                background: #eaebf0;
                .switch-item {
                    line-height: 17px;
                    padding: 1px 6px;
                    cursor: pointer;
                    color: #63656e;
                    background: #eaebf0;
                    border-radius: 2px;
                    &:hover {
                        color: #313238;
                    }
                    &.active {
                        color: #313238;
                        background: #fafbfd;
                    }
                }
            }
            .more {
                position: absolute;
                bottom: 40px;
                display: inline-block;
                color: #3a84ff;
                cursor: pointer;
                .arrow-right-icon {
                    display: inline-block;
                    height: 10px;
                    width: 23px;
                    position: relative;
                    left: 3px;
                    background: url('../images/community/arrow-right.png');
                    background-size: cover;
                }
                &:hover {
                    color: #1768ef;
                    .arrow-right-icon {
                        background: url('../images/community/arrow-right1.png');
                        background-size: cover;
                    }
                }
            }
        }
        .recommend-qa {
            width: 1200px;
            margin: 0 auto;
            .title {
                height: 27px;
            }
            .qa-wrapper {
                position: relative;
                display: flex;
                align-items: flex-start;
                .qa-content {
                    flex: 1;
                    min-height: 300px;
                    padding: 32px 30px 60px 0;
                    .qa-item {
                        display: flex;
                        align-self: start;
                        margin-bottom: 25px;
                        padding-bottom: 24px;
                        border-bottom: 1px solid #eaebf0;
                        .qa-left {
                            width: 52px;
                            height: 52px;
                            text-align: center;
                            opacity: 0.84;
                            font-size: 12px;
                            color: #3a84ff;
                            line-height: 17px;
                            padding-top: 8px;
                            margin-right: 16px;
                            background: rgba($color: #e1ecff, $alpha: 0.53);
                            border-radius: 2px;
                            cursor: pointer;
                            .count {
                                line-height: 20px;
                            }
                            &:hover {
                                background: rgba($color: #e1ecff, $alpha: 0.84);
                            }
                        }
                        .qa-right {
                            .title {
                                font-size: 16px;
                                line-height: 24px;
                                margin-bottom: 11px;
                                color: #313238;
                                &:hover {
                                    cursor: pointer;
                                    color: #3a84ff;
                                }
                            }
                            .footer {
                                margin-top: 20px;
                                display: flex;
                                align-items: center;
                                font-size: 12px;
                                line-height: 17px;
                                color: #63656e;
                                .footer-item {
                                    display: flex;
                                    align-items: center;
                                    margin-right: 26px;
                                    .smart-icon {
                                        height: 16px;
                                        width: 16px;
                                        position: relative;
                                        top: -1px;
                                        z-index: 2;
                                        margin-right: 5px;
                                        &::before, &::after {
                                            content: '';
                                            height: 16px;
                                            width: 16px;
                                            position: absolute;
                                            z-index: 1;
                                            display: none;
                                        }
                                        &.view-icon {
                                            background: url('../images/community/eye-open.png');
                                            background-size: 100% 100%;
                                        }
                                        &.follow-icon {
                                            background: url('../images/community/like3.png');
                                            background-size: 100% 100%;
                                            &::before {
                                                background: url('../images/community/like4.png');
                                                background-size: 100% 100%;
                                            }
                                            &::after {
                                                background: url('../images/community/like5.png');
                                                background-size: 100% 100%;
                                            }
                                        }
                                    }
                                    .user-logo {
                                        height: 16px;
                                        width: 16px;
                                        border-radius: 50%;
                                        margin: 0 7px 0 5px;
                                        cursor: pointer;
                                    }
                                    .user-name {
                                        margin-right: 2px;
                                        cursor: pointer;
                                        &:hover {
                                            color: #3a84ff;
                                        }
                                    }
                                    .user-identity {
                                        width: 16px;
                                        height: 16px;
                                        margin-right: 11px;
                                    }
                                    &:hover {
                                        &:nth-child(2) {
                                            cursor: pointer;
                                            color: #3a84ff;
                                        }
                                        .smart-icon::before {
                                            display: block;
                                            z-index: 3;
                                        }
                                    }
                                    &.is-active {
                                        color: #3a84ff;
                                        .smart-icon::after {
                                            display: block;
                                            z-index: 3;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .respondent-content {
                    width: 350px;
                    height: 488px;
                    position: relative;
                    top: -28px;
                    min-height: 300px;
                    position: relative;
                    padding: 26px 0 24px;
                    background: #fafbfd;
                    border-radius: 2px;
                    .active-title {
                        line-height: 22px;
                        padding: 0 24px;
                        margin-bottom: 24px;
                        .title {
                            font-size: 16px;
                            color: #313238;
                        }
                    }
                    .active-user-item {
                        height: 48px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        color: #63656e;
                        margin-bottom: 16px;
                        padding: 0 24px;
                        font-size: 12px;
                        .user-avatar {
                            width: 37px;
                            height: 48px;
                            position: relative;
                            margin-right: 14px;
                            .avatar {
                                position: absolute;
                                left: 2.5px;
                                bottom: 7px;
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                                border: 1px solid #dcdee5;
                            }
                        }
                        &.is-crown .avatar{
                            border: none;
                            bottom: 2.5px;
                        }
                        .user-message {
                            flex: 1;
                            .user-name {
                                font-weight: 700;
                                font-family: Helvetica, Helvetica-Bold;
                                color: #63656e;
                                margin-bottom: 3px;
                                margin-right: 2px;
                            }
                            .reply-info {
                                color: #63656e;
                            }
                            &:hover {
                                color: #313238;
                            }
                        }
                        .follow-btn {
                            width: 46px;
                            height: 20px;
                            text-align: center;
                            line-height: 20px;
                            font-size: 12px;
                            border-radius: 2px;
                            &.followed {
                                background: #dcdee5;
                                color: #63656e;
                                &:hover {
                                    background: #c4c6cc;
                                }
                            }
                            &.not-follow {
                                color: #3a84ff;
                                background: #fff;
                                border: 1px solid #5082fa;
                                line-height: 18px;
                                &:hover {
                                    background: #3a84ff;
                                    color: #fff;
                                }
                            }
                        }
                        &:last-child {
                            margin-bottom: 0;
                        }
                        &:hover {
                            background: #f5f7fa;
                            .user-name {
                                color: #313238;
                            }
                        }
                    }
                    .data-null {
                        text-align: center;
                        padding: 100px 0;
                    }
                }
            }
        }
        
        .recommend-article {
            width: 100%;
            padding-top: 48px;
            background: #fafbfd;
            .article-content {
                position: relative;
                width: 1200px;
                margin: 0 auto;
                display: flex;
                align-items: flex-start;
            }
            .article-list {
                flex: 1;
                min-height: 300px;
                padding: 32px 36px 60px 0 ;
                .article-item {
                    display: flex;
                    align-items: start;
                    margin-bottom: 25px;
                    padding-bottom: 23px;
                    border-bottom: 1px solid #eaebf0;
                    .article-left {
                        flex: 1;
                        margin-right: 17px;
                        .header {
                            display: flex;
                            .reprint {
                                width: 44px;
                                height: 22px;
                                background: #FFF1DB;
                                color: #FE9C00;
                                border-radius: 2px;
                                font-family: MicrosoftYaHei;
                                font-size: 12px;
                                text-align: center;
                                line-height: 22px;
                                margin-right: 8px;
                            }
                            .original {
                                width: 44px;
                                height: 22px;
                                background: #E4FAF0;
                                border-radius: 2px;
                                font-family: MicrosoftYaHei;
                                font-size: 12px;
                                color: #14A568;
                                text-align: center;
                                line-height: 22px;
                                margin-right: 8px;
                            }
                            .title {
                                font-size: 16px;
                                color: #313238;
                                line-height: 24px;
                                margin-bottom: 11px;
                                cursor: pointer;
                                &:hover {
                                    color: #3a84ff;
                                }
                            }
                        }
                        .desc {
                            margin-top: 13px;
                            line-height: 22px;
                            cursor: pointer;
                            overflow:hidden;
                            text-overflow:ellipsis;
                            display:-webkit-box;
                            -webkit-box-orient:vertical;
                            -webkit-line-clamp:2;
                            word-break: break-all;
                            &:hover {
                                color: #313238;
                            }
                        }
                        .footer {
                            display: flex;
                            align-items: center;
                            font-size: 12px;
                            line-height: 17px;
                            margin-top: 24px;
                            color: #63656e;
                            .footer-item {
                                display: flex;
                                align-items: center;
                                margin-right: 25px;
                                cursor: pointer;
                                &:first-child, &:last-child {
                                    cursor: default;
                                }
                                &:nth-child(4){
                                    margin-right: 29px;
                                }
                                .smart-icon {
                                    height: 16px;
                                    width: 16px;
                                    margin-right: 6px;
                                    position: relative;
                                    z-index: 2;
                                    &::before, &::after {
                                        content: '';
                                        height: 16px;
                                        width: 16px;
                                        position: absolute;
                                        z-index: 1;
                                        display: none;
                                    }
                                    &.view-icon {
                                        background: url('../images/community/eye-open.png');
                                        background-size: 100% 100%;
                                    }
                                    &.comment-icon {
                                        background: url('../images/community/comment3.png');
                                        background-size: 100% 100%;
                                        &::before {
                                            background: url('../images/community/comment4.png');
                                            background-size: 100% 100%;
                                        }
                                        &::after {
                                            background: url('../images/community/comment5.png');
                                            background-size: 100% 100%;
                                        }
                                    }
                                    &.like-icon {
                                        background: url('../images/community/great3.png');
                                        background-size: 100% 100%;
                                        &::before {
                                            background: url('../images/community/great4.png');
                                            background-size: 100% 100%;
                                        }
                                        &::after {
                                            background: url('../images/community/great2.png');
                                            background-size: 100% 100%;
                                        }
                                    }
                                    &.collect-icon {
                                        background: url('../images/community/favorite3.png');
                                        background-size: 100% 100%;
                                        &::before {
                                            background: url('../images/community/favorite4.png');
                                            background-size: 100% 100%;
                                        }
                                        &::after {
                                            background: url('../images/community/favorite2.png');
                                            background-size: 100% 100%;
                                        }
                                    }
                                }
                                .user-logo {
                                    height: 16px;
                                    width: 16px;
                                    border-radius: 50%;
                                    margin: 0 7px 0 5px;
                                    cursor: pointer;
                                }
                                .user-name {
                                    margin-right: 2px;
                                    cursor: pointer;
                                    &:hover {
                                        color: #3a84ff;
                                    }
                                }
                                .user-identity {
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 11px;
                                }
                                &:hover {
                                    &:not(.default) {
                                        cursor: pointer;
                                        color: #3a84ff;
                                    }
                                    .smart-icon::before {
                                        display: block;
                                        z-index: 3;
                                    }
                                }
                                &.is-active {
                                    color: #3a84ff;
                                    .smart-icon {
                                        background: none;
                                        &::before {
                                            display: none;
                                        }
                                        &::after {
                                            display: block;
                                            z-index: 3;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .article-right {
                        flex-shrink: 0;
                        img {
                            max-width: 180px;
                            max-height: 120px;
                        }
                    }
                }
            }
            .article-rank {
                width: 350px;
                height: 642px;
                min-height: 300px;
                position: relative;
                border-radius: 2px;
                background: #fff;
                padding: 0 15px 18px 27px;
                > .article-title {
                    padding-left: 3px;
                    line-height: 22px;
                    margin: 26px 0 16px;
                    .title {
                        font-size: 16px;
                        color: #313238;
                    }
                }
                .rank-item {
                    display: flex;
                    align-items: center;
                    height: 48px;
                    font-size: 12px;
                    margin-bottom: 16px;
                    .view-box {
                        flex-shrink: 0;
                        width: 40px;
                        height: 40px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        padding-top: 3px;
                        background: rgba($color: #dcdee5, $alpha: 0.3);
                        border-radius: 2px;
                        margin-right: 7px;
                        &.rank0 {
                            color: #ff9c01;
                            background: rgba($color: #ffdd88, $alpha: 0.3);
                        }
                        &.rank1 {
                            color: #db8e48;
                            background: rgba($color: #eda86f, $alpha: 0.3);
                        }
                        &.rank2 {
                            color: #3a84ff;
                            background: rgba($color: #e1ecff, $alpha: 0.3);
                        }
                    }
                    .title {
                        width: 250px;
                        color: #313238;
                        line-height: 20px;
                        cursor: pointer;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap;
                        &:hover {
                            color: #3a84ff;
                        }
                    }
                    .user-name {
                        position: relative;
                        color: #979BA5;
                        cursor: pointer;
                        &:hover {
                            color: #313238;
                        }
                    }
                    .user-identity {
                        width: 14px;
                        height: 14px;
                    }
                    .art_nums {
                        color: #979BA5;
                        margin-left: 10px;
                        position: relative;
                        &::before {
                            content: '';
                            width: 2px;
                            height: 2px;
                            background: #c4c6cc;
                            border-radius: 50%;
                            position: absolute;
                            left: -10px;
                            top: 9px;
                        }
                    }
                    &.is-crown {
                        padding-top: 8px;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                .data-null {
                    text-align: center;
                    padding: 50px 0;
                }
            }
        }
        .course-study {
            padding-top: 48px;
            margin-bottom: 25px;
            .course-wrapper {
                width: 1200px;
                margin: 32px auto 0;
                .course-item {
                    width: 388px;
                    height: 220px;
                    color: #fff;
                    position: relative;
                    border-radius: 2px;
                    cursor: pointer;
                    overflow: hidden;
                    .img {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background: url('../images/community/cover01.png') no-repeat;
                        background-size: cover;
                    }
                    .mask {
                        position: absolute;
                        left: 0;
                        top: 0;
                        z-index: 3;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #000;
                        background: rgba($color: #000000, $alpha: 0);
                        transition: .3s;
                        .play-btn {
                            width: 80px;
                            height: 80px;
                            margin: auto;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: rgba($color: #000, $alpha: 0.5);
                            border-radius: 50%;
                            opacity: 0;
                            transition: .5s;
                            &::after {
                                content: "";
                                display: inline-block;
                                border-left: 12px solid #fff;
                                border-top: 8px solid transparent;
                                border-bottom: 8px solid transparent;
                            }
                            &:hover {
                                transform: scale(1.1);
                            }
                        }
                    }
                    .topic {
                        position: absolute;
                        left: 10px;
                        top: 12px;
                        font-size: 12px;
                        line-height: 17px;
                    }
                    .name {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        width: 100%;
                        padding: 0 10px;
                        font-size: 22px;
                        line-height: 25px;
                        text-align: center;
                        font-family: TencentSansW7, TencentSansW7-Regular;
                        -webkit-transform: translate(-50%,-50%);
                        transform: translate(-50%,-50%);
                    }
                    .duration {
                        position: absolute;
                        bottom: 9px;
                        right: 10px;
                        padding: 2px 3px 2px 23px;
                        background: #39384f;
                        border-radius: 2px;
                        opacity: .8;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 18px;
                        &::after {
                            position: absolute;
                            bottom: 6px;
                            left: 8px;
                            content: "";
                            display: block;
                            border-left: 7px solid #fff;
                            border-top: 5px solid transparent;
                            border-bottom: 5px solid transparent;
                        }
                    }
                    &:hover {
                        .mask {
                            background: rgba($color: #000000, $alpha: 0.4);
                        }
                        .play-btn {
                            opacity: 1;
                        }
                    }
                }
            }
        }
        .hot-download {
            margin-bottom: 78px;
            .download-wrapper {
                width: 1200px;
                margin: 32px auto 0;
                display: flex;
                align-items: center;
                .download-item {
                    width: 288px;
                    height: 180px;
                    position: relative;
                    padding: 35px 18px 0;
                    margin-right: 16px;
                    cursor: pointer;
                    background: #eef3fe url('../images/community/download-bg.png') no-repeat;
                    background-size: 100% auto;
                    &:nth-child(2) {
                        background: #eef3fe url('../images/community/download-bg1.png') no-repeat;
                        background-size: 100% auto;
                    }
                    .label {
                        position: absolute;
                        top: 8px;
                        right: 10px;
                        width: 44px;
                        height: 22px;
                        line-height: 18px;
                        text-align: center;
                        color: #fff;
                        background: #3a84ff;
                        border-radius: 2px;
                        &.required {
                            background: #42b685;
                        }
                    }
                    .title {
                        font-size: 22px;
                        color: #63656e;
                        line-height: 33px;
                        margin-bottom: 3px;
                        font-family: TencentSansW7, TencentSansW7-Regular;
                    }
                    .desc {
                        font-size: 16px;
                        color: #63656e;
                        font-family: TencentSansW3, TencentSansW7-Regular;
                    }
                    .version {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        height: 40px;
                        width: 288px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        color: #fff;
                        padding: 0 16px;
                        background: rgba($color: #000, $alpha: 0.4);
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    &:hover {
                        box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.10), 0px 2px 6px 4px rgba(25,25,41,0.05);
                    }
                }
            }
        }
        .community-edition {
            height: 320px;
            width: 100%;
            padding-top: 78px;
            background: url('../images/community/community-bg.png') no-repeat;
            background-size: cover;
            .title {
                font-size: 24px;
                text-align: center;
                color: #313238;
                margin-bottom: 24px;
            }
            .desc {
                font-size: 16px;
                color: #63656e;
                text-align: center;
                line-height: 24px;
                margin-bottom: 30px;
            }
            .experience-btn {
                width: 200px;
                height: 40px;
                text-align: center;
                line-height: 38px;
                color: #fff;
                font-size: 16px;
                margin: 0 auto;
                background: #3a84ff;
                border: 1px solid #5082fa;
                border-radius: 21px;
                cursor: pointer;
                &:hover {
                    background: #1768ef;
                    border: 1px solid #5082fa;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// forum.vue?9b7b7f58